"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[222],{

/***/ 61467:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/External_Data_Solutions.4d134abd.svg","height":506,"width":588});

/***/ }),

/***/ 5659:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Featured1.fe8e6ccc.svg","height":56,"width":56});

/***/ }),

/***/ 10222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ ThirdPartyOrExternalData; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/platform/views/Auth/SignUp.jsx + 1 modules
var SignUp = __webpack_require__(8338);
// EXTERNAL MODULE: ./src/landingPage/views/GeneratedTemplate/utils/sanitizeSlug.js
var sanitizeSlug = __webpack_require__(78732);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/views/LandingTemplate/components/LandingCustomers.jsx
var LandingCustomers = __webpack_require__(59666);
// EXTERNAL MODULE: ./src/landingPage/views/LandingTemplate/components/LandingSourceCarousel.jsx
var LandingSourceCarousel = __webpack_require__(96615);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Clearco.svg
var Clearco = __webpack_require__(8869);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Openly.svg
var Openly = __webpack_require__(68197);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers.svg
var Farmers = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered.svg
var StandardChartered = __webpack_require__(86051);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz.svg
var Anz = __webpack_require__(33911);
// EXTERNAL MODULE: ./src/landingPage/views/HomePage/assets/icons/Featured1.svg
var Featured1 = __webpack_require__(5659);
;// CONCATENATED MODULE: ./src/landingPage/views/HomePage/assets/icons/Featured2.svg
/* harmony default export */ var Featured2 = ({"src":"/_next/static/media/Featured2.72cb9c07.svg","height":56,"width":56});
;// CONCATENATED MODULE: ./src/landingPage/views/HomePage/assets/icons/Featured3.svg
/* harmony default export */ var Featured3 = ({"src":"/_next/static/media/Featured3.1d4a511b.svg","height":56,"width":56});
// EXTERNAL MODULE: ./src/landingPage/views/HomePage/assets/External_Data_Solutions.svg
var External_Data_Solutions = __webpack_require__(61467);
;// CONCATENATED MODULE: ./src/landingPage/views/Campaigns/ThirdPartyOrExternalData.jsx















var ThirdPartyOrExternalData = function(param) {
    var dataSources = param.dataSources, keyword = param.keyword;
    var landingCustomersData = {
        fields: {
            subheadline: "Join the customers already unlocking the power of ".concat(keyword, " data with Demyst:"),
            logos: [
                {
                    image: Farmers/* default.src */.Z.src,
                    image_alt: "Farmers Insurance"
                },
                {
                    image: Anz/* default.src */.Z.src,
                    image_alt: "ANZ"
                },
                {
                    image: StandardChartered/* default.src */.Z.src,
                    image_alt: "Standard Chartered"
                },
                {
                    image: Openly/* default.src */.Z.src,
                    image_alt: "Openly"
                },
                {
                    image: Clearco/* default.src */.Z.src,
                    image_alt: "Clearco (formerly Clearbank)"
                }, 
            ]
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (0,clsx_m/* default */.Z)("LandingHero-background", "Campaign", "Campaign-WithCarousel"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingSourceCarousel/* LandingSourceCarousel */.g, {
                        backgroundColor: "teal",
                        data: dataSources
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("Campaign", "Campaign-WithCarousel", "LandingHero", "LandingHero-align-left", "LandingHero-type-platform-sign-up"),
                        id: "hero",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "section-layout",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "LandingHero-title",
                                        children: [
                                            "Enrich Your Data With ",
                                            (0,sanitizeSlug/* sanitizeSlug */.Ql)(keyword, "titlecase"),
                                            " Data APIs"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "LandingHero-subtitle",
                                        children: [
                                            "Demyst simplifies and accelerates access to",
                                            " ",
                                            (0,sanitizeSlug/* sanitizeSlug */.Ql)(keyword, "sentenceLowerCase"),
                                            " data by allowing businesses to create",
                                            " ",
                                            (0,sanitizeSlug/* sanitizeSlug */.Ql)(keyword, "sentenceLowerCase"),
                                            " data APIs to optimize their operations and elevate their intelligence."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "section-layout",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUp/* SignUpForm */.W, {
                                    className: "LandingHero-form",
                                    showLogInLink: false,
                                    titleOverride: "Sign Up to the Demyst Platform and Access Free Sample Data",
                                    sentTitleOverride: "",
                                    sentMessageOverride: ""
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("LandingMainContent", "LandingMainContent-background-gray-2", "LandingMainContent-align-left", "LandingMainContent-text_image", "Campaign"),
                id: "api-deployment",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "section-layout",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)("LandingTextImageContent-col", "LandingTextImageContent-col-text", "LandingTextImageContent-col-text-position-left"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "The all-in-one platform for external data"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "LandingTextImageContent-customUl2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: Featured1/* default.src */.Z.src,
                                                    alt: "",
                                                    width: "48",
                                                    height: "48",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                            children: [
                                                                "Rapidly deploy ",
                                                                keyword,
                                                                " data"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "Deploy Data APIs or shared full files of ",
                                                                keyword,
                                                                " data up to 10x faster. Demyst integrates into your production applications, CRM, data lake, warehouse and more."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: Featured2.src,
                                                    alt: "",
                                                    width: "48",
                                                    height: "48",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: "Ease compliance burden with a single partnership"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Demyst delivers an industry leading data provider certification process for safe and compliant data access. We perform regular legal, privacy and security due diligence so that you don't need to for all the data you deploy."
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: Featured3.src,
                                                    alt: "",
                                                    width: "48",
                                                    height: "48",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                            children: [
                                                                "Manage all your ",
                                                                keyword,
                                                                " data in one place"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "With Demyst you can use a single global interface for all your ",
                                                                keyword,
                                                                " data discovery, solution builds and deployments."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "LandingTextImageContent-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: External_Data_Solutions/* default.src */.Z.src,
                                alt: "",
                                loading: "lazy",
                                width: "588",
                                height: "506"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("LandingMainContent", "LandingMainContent-background-blue", "LandingMainContent-align-center", "LandingMainContent-customers", "Campaign"),
                id: "customers",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCustomers/* LandingCustomers */.l, {
                    data: landingCustomersData
                })
            })
        ]
    });
};


/***/ }),

/***/ 78732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ql": function() { return /* binding */ sanitizeSlug; }
/* harmony export */ });
/* unused harmony exports slugTagNameMap, slugTagCategoryMap, slugRegionMap, availableAcronyms, availableCustomCaseWords */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10253);

var slugTagNameMap = [
    {
        slug: "kyb-workflow-automation",
        tag: "KYB Workflow Automation"
    },
    {
        slug: "kyb",
        tag: "KYB Workflow Automation"
    },
    {
        slug: "kyc-Workflow-automation",
        tag: "KYC Workflow Automation"
    },
    {
        slug: "kyc",
        tag: "KYC Workflow Automation"
    },
    {
        slug: "application-pre-fill",
        tag: "Application Pre-fill"
    },
    {
        slug: "prefill",
        tag: "Application Pre-fill"
    },
    {
        slug: "business-decision-making",
        tag: "Business Decision-making"
    },
    {
        slug: "lead-targeting",
        tag: "Lead Targeting"
    },
    {
        slug: "portfolio-monitoring",
        tag: "Portfolio Monitoring"
    },
    {
        slug: "lead-enrichment",
        tag: "Lead Enrichment"
    },
    {
        slug: "leads",
        tag: "Lead Enrichment"
    },
    {
        slug: "credit-score-consolidation",
        tag: "Credit Score Consolidation"
    },
    {
        slug: "credit",
        tag: "Credit Score Consolidation"
    },
    {
        slug: "buy-now-pay-later",
        name: "Buy Now Pay Later"
    },
    {
        slug: "ecommerce",
        name: "eCommerce"
    },
    {
        slug: "retail",
        name: "Retail"
    },
    {
        slug: "marketing",
        name: "Marketing"
    },
    {
        slug: "insurance",
        name: "Insurance"
    },
    {
        slug: "financial-services",
        name: "Financial Services"
    }, 
];
var slugTagCategoryMap = [
    {
        slug: "use-case",
        tag: "Use-Case"
    },
    {
        slug: "industry",
        tag: "Industry"
    }, 
];
var slugRegionMap = [
    {
        slug: "united-states",
        region: "United States",
        adjective: "American"
    },
    {
        slug: "united-kingdom",
        region: "United Kingdom",
        adjective: "British"
    },
    {
        slug: "australia",
        region: "Australia",
        adjective: "Australian"
    },
    {
        slug: "philippines",
        region: "Philippines",
        adjective: "Philippine"
    },
    // nice typo, geniuses
    {
        slug: "phillippines",
        region: "Phillippines",
        adjective: "Phillippine"
    },
    {
        slug: "global",
        region: "Global",
        adjective: "Worldwide"
    },
    {
        slug: "new-zealand",
        region: "New Zealand",
        adjective: "New Zealand"
    },
    {
        slug: "canada",
        region: "Canada",
        adjective: "Canadian"
    },
    {
        slug: "india",
        region: "India",
        adjective: "Indian"
    },
    {
        slug: "germany",
        region: "Germany",
        adjective: "German"
    },
    {
        slug: "mexico",
        region: "Mexico",
        adjective: "Mexican"
    },
    {
        slug: "indonesia",
        region: "Indonesia",
        adjective: "Indonesian"
    },
    {
        slug: "singapore",
        region: "Singapore",
        adjective: "Singaporean"
    },
    {
        slug: "malaysia",
        region: "Malaysia",
        adjective: "Malaysian"
    },
    {
        slug: "france",
        region: "France",
        adjective: "French"
    },
    {
        slug: "spain",
        region: "Spain",
        adjective: "Spanish"
    },
    {
        slug: "vietnam",
        region: "Vietnam",
        adjective: "Vietnamese"
    },
    {
        slug: "thaliand",
        region: "Thaliand",
        adjective: "Thai"
    },
    {
        slug: "hong-kong",
        region: "Hong Kong",
        adjective: "Hongkongese"
    }, 
];
var availableAcronyms = [
    "kyb",
    "kyc",
    "b2b"
];
var availableCustomCaseWords = [
    "eCommerce",
    "SaaS",
    "DaaS"
];
var sanitizeSlug = function(slug) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "titlecase";
    if (!slug) return null;
    var capitalizeAcronyms = function(string) {
        var acrononymsOrred = availableAcronyms.join("|");
        var regex = new RegExp(acrononymsOrred, "ig");
        return string.replace(regex, function(match) {
            return match.toUpperCase();
        });
    };
    var capitalizeFirstLetter = function(string) {
        return string.charAt(0).toUpperCase() + string.substr(1).toLowerCase();
    };
    var setCustomCase = function(string) {
        var availbleCustomWordsOrred = availableCustomCaseWords.join("|").toLowerCase();
        var regex = new RegExp(availbleCustomWordsOrred, "ig");
        return string.replace(regex, function(match) {
            return availableCustomCaseWords.filter(function(item) {
                return item.toLowerCase() === match.toLowerCase();
            })[0];
        });
    };
    var toTitleCase = function(string) {
        return string.replace(/---/g, " _ ") // first convert three straight hyphens to temp _
        .replace(/-/g, " ") // then replace all hyphens
        .replace(/_/g, "-") // then turn temp _ back to a hyphen
        .replace(/,/g, "") // remove commas
        .replace(/\w\S*/g, function(text) {
            return capitalizeFirstLetter(text);
        }); // finally titleCase
    };
    if (type === "titlecase") {
        var title = toTitleCase(slug);
        title = capitalizeAcronyms(title);
        title = setCustomCase(title);
        return title;
    }
    if (type === "tagName") {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(slugTagNameMap.filter(function(item) {
            return item.slug === slug;
        }).map(function(item) {
            return item.tag;
        }), 1), slugToTag = ref[0];
        if (slugToTag) {
            return slugToTag;
        }
        var tagAlt = toTitleCase(slug);
        tagAlt = capitalizeAcronyms(tagAlt);
        tagAlt = setCustomCase(tagAlt);
        return tagAlt;
    }
    if (type === "tagCategory") {
        var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(slugTagCategoryMap.filter(function(item) {
            return item.slug === slug;
        }).map(function(item) {
            return item.tag;
        }), 1), slugToTag1 = ref1[0];
        if (slugToTag1) {
            return slugToTag1;
        }
        var tagAlt1 = toTitleCase(slug);
        tagAlt1 = capitalizeAcronyms(tagAlt1);
        tagAlt1 = setCustomCase(tagAlt1);
        return tagAlt1;
    }
    if (type === "region") {
        var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(slugRegionMap.filter(function(item) {
            return item.slug === slug;
        }).map(function(item) {
            return item.region;
        }), 1), slugToRegion = ref2[0];
        if (slugToRegion) {
            return slugToRegion;
        }
        var regionAlt = toTitleCase(slug);
        regionAlt = capitalizeAcronyms(regionAlt);
        regionAlt = setCustomCase(regionAlt);
        return regionAlt;
    }
    if (type === "regionAdjective") {
        var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(slugRegionMap.filter(function(item) {
            return item.slug === slug;
        }).map(function(item) {
            return item.adjective;
        }), 1), slugToRegion1 = ref3[0];
        if (slugToRegion1) {
            return slugToRegion1;
        }
        var regionAlt1 = toTitleCase(slug);
        regionAlt1 = capitalizeAcronyms(regionAlt1);
        regionAlt1 = setCustomCase(regionAlt1);
        return regionAlt1;
    }
    if (type === "sentence") {
        var sentence = capitalizeFirstLetter(slug);
        sentence = capitalizeAcronyms(sentence);
        sentence = setCustomCase(sentence);
        return sentence;
    }
    if (type === "sentenceLowerCase") {
        var sentence1 = slug.toLowerCase();
        sentence1 = capitalizeAcronyms(sentence1);
        sentence1 = setCustomCase(sentence1);
        return sentence1;
    }
    var title1 = toTitleCase(slug);
    title1 = capitalizeAcronyms(title1);
    title1 = setCustomCase(title1);
    return title1;
};


/***/ }),

/***/ 49570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ LandingButterLink; }
/* harmony export */ });
/* unused harmony export onLandingButterLinkClick */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67474);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_LinkButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84135);







var onLandingButterLinkClick = function(e, pathname, section) {
    var target = e === null || e === void 0 ? void 0 : e.target;
    (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_1__/* .sendGaEvent */ .k8)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        action: "Button Click",
        category: "SEO"
    }, target && {
        label: "".concat(target === null || target === void 0 ? void 0 : target.innerText.slice(0, 10), " - ").concat(section ? "".concat(section.slice(0, 10), " - ") : " ").concat(pathname)
    }));
    return false;
};
var LandingButterLink = function(param) {
    var url = param.url, className = param.className, _external = param.external, external = _external === void 0 ? false : _external, section = param.section, children = param.children, demystIcon = param.demystIcon, variant = param.variant, size = param.size, onClick = param.onClick, _noStyle = param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, mainCTA = param.mainCTA;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var pathname = router.asPath;
    var sanitizeButterUrl = function(url) {
        var isValidHttpUrl = function(string) {
            var jsUrl;
            try {
                jsUrl = new URL(string);
            } catch (e) {
                return false;
            }
            return jsUrl.protocol === "http:" || jsUrl.protocol === "https:";
        };
        if (isValidHttpUrl(url)) return {
            target: "_blank",
            rel: "noreferrer noopener",
            to: new URL(url)
        };
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            to: url.endsWith("/") ? url.slice(0, -1) : url
        }, external === true && {
            isExternal: true
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LinkButton__WEBPACK_IMPORTED_MODULE_3__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sanitizeButterUrl(url)), {
        className: className,
        onClick: function(event) {
            onLandingButterLinkClick(event, pathname, section);
            (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(onClick, Function) && onClick();
        },
        demystIcon: demystIcon,
        size: size,
        variant: variant,
        noStyle: noStyle,
        mainCTA: mainCTA,
        children: children
    }));
};


/***/ }),

/***/ 93022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LandingCtas; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _LandingButterLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49570);



var LandingCtas = function(param) {
    var ctas = param.ctas;
    if (!ctas) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "LandingCtas",
        children: ctas === null || ctas === void 0 ? void 0 : ctas.map(function(cta) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingButterLink__WEBPACK_IMPORTED_MODULE_1__/* .LandingButterLink */ .v, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("LandingCtas-button", (cta === null || cta === void 0 ? void 0 : cta.button_variant) && "LandingCtas-button-".concat(cta === null || cta === void 0 ? void 0 : cta.button_variant)),
                variant: cta === null || cta === void 0 ? void 0 : cta.button_variant,
                demystIcon: (cta === null || cta === void 0 ? void 0 : cta.show_button_logo) === true,
                url: cta === null || cta === void 0 ? void 0 : cta.button_url,
                section: cta === null || cta === void 0 ? void 0 : cta.section,
                size: cta === null || cta === void 0 ? void 0 : cta.button_size,
                onClick: cta === null || cta === void 0 ? void 0 : cta.onClick,
                mainCTA: cta === null || cta === void 0 ? void 0 : cta.mainCTA,
                children: cta === null || cta === void 0 ? void 0 : cta.button_label
            }, cta);
        })
    });
};


/***/ }),

/***/ 59666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ LandingCustomers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LandingCtas__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93022);


var LandingCustomers = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "section-layout",
        children: [
            (data === null || data === void 0 ? void 0 : (ref = data.fields) === null || ref === void 0 ? void 0 : ref.headline) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: data === null || data === void 0 ? void 0 : (ref1 = data.fields) === null || ref1 === void 0 ? void 0 : ref1.headline
            }),
            (data === null || data === void 0 ? void 0 : (ref2 = data.fields) === null || ref2 === void 0 ? void 0 : ref2.subheadline) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: data === null || data === void 0 ? void 0 : (ref3 = data.fields) === null || ref3 === void 0 ? void 0 : ref3.subheadline
            }),
            (data === null || data === void 0 ? void 0 : (ref4 = data.fields) === null || ref4 === void 0 ? void 0 : ref4.logos) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "LandingCustomers",
                children: data === null || data === void 0 ? void 0 : (ref5 = data.fields) === null || ref5 === void 0 ? void 0 : ref5.logos.map(function(logo) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: logo.image,
                        alt: logo.image_alt,
                        loading: "lazy"
                    }, logo);
                })
            }),
            (data === null || data === void 0 ? void 0 : (ref6 = data.fields) === null || ref6 === void 0 ? void 0 : ref6.ctas) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingCtas__WEBPACK_IMPORTED_MODULE_1__/* .LandingCtas */ .f, {
                ctas: data === null || data === void 0 ? void 0 : (ref7 = data.fields) === null || ref7 === void 0 ? void 0 : ref7.ctas
            })
        ]
    });
};


/***/ }),

/***/ 96615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ LandingSourceCarousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var LandingSourceCarousel = function(param) {
    var data = param.data, options = param.options;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "LandingSourceCarousel-wrapper",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                className: "LandingSourceCarousel"
            }, options), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "LandingSourceCarousel-sources-wrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "LandingSourceCarousel-sources",
                        children: data === null || data === void 0 ? void 0 : data.filter(function(s) {
                            return s.logo;
                        }).map(function(source) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "LandingSourceCarousel-source",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: source.logo,
                                        alt: source.name,
                                        height: "64",
                                        width: "64",
                                        loading: "lazy"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: source.name
                                    })
                                ]
                            }, source.name);
                        })
                    })
                })
            }))
        })
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        }
    }, isExternal && {
        target: "_blank",
        rel: "noreferrer"
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ })

}]);